// Messages for operator/quotes/QuoteStatusModal (auto-merged by lib/i18n.ts).
export const en = {
  'operator.quote_status_modal.title': 'Update quote status',
  'operator.quote_status_modal.cancel': 'Cancel',
  'operator.quote_status_modal.update': 'Update status',
  'operator.quote_status_modal.status': 'Status',
  'operator.quote_status_modal.current_suffix': ' (current)',
}

export const zhTW = {
  'operator.quote_status_modal.title': '更新報價狀態',
  'operator.quote_status_modal.cancel': '取消',
  'operator.quote_status_modal.update': '更新狀態',
  'operator.quote_status_modal.status': '狀態',
  'operator.quote_status_modal.current_suffix': '（目前）',
}
